import React from 'react';

import classNames from 'classnames';

import Modal from './Modal';

const ModalFooter = (data) => (
  <Modal.Consumer>
    {(context) => (
      <div className={classNames('modal-footer', data.className)}>
        {typeof data.children === 'function'
          ? data.children(context)
          : data.children}
      </div>
    )}
  </Modal.Consumer>
);

export default ModalFooter;
